import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import {
    getProcessButtons, getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, setBadgeStatusGeneric, settings, getResponse, getLanguageObj
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import { AdvancedCommandClass } from '../../classes/ai/advancedCommandClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AdvancedCommandService } from '../../services/advancedCommand/AdvancedCommandService';

const { html, icons, labels, messages, images } = settings;

const currentMethod = 'AdvancedCommandAddEditDetails - function';

export default function AdvancedCommandAddEditDetails({
    $ = {},
    auth = {},
    dtId = '',
    dtRowId = 0,
    type = 0,
    showModal = false,
    setShowModal = () => { },
    advancedCommand = AdvancedCommandClass?.getClass(),
    setAdvancedCommand = () => { },
    textAreaAnswerId = '',
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [errors, setErrors] = useState({
        description: '',
    });

    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });

    const isMount = useRef(true);
    const chkAdvancedCommandStatusId = 'chkAdvancedCommandStatus';
    //#endregion variables

    //#region methods
    const setDefaultValue = ({
        isModalClose = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            setErrors({ description: '' });
            if (isModalClose) {
                setAdvancedCommand({});
                setShowModal(!isModalClose);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.log(response);
        }
    };

    const advancedCommandAdd = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'advancedCommandAdd';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await AdvancedCommandService.createAdvancedCommand({
                token: auth?.account?.tokenVzLaML?.token,
                data: advancedCommand,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const advancedCommand_ = response?.result?.advancedCommand || {};
            setAdvancedCommand(advancedCommand_);

            const advancedCommandDtLocal = [
                advancedCommand_?.description,
                setBadgeStatusGeneric({
                    type: (advancedCommand_?.status ? 0 : 1),
                    value: (advancedCommand_?.status ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id])
                }),
                getProcessButtons({
                    id: advancedCommand_?.id,
                    description: advancedCommand_?.description,
                    detailsShow: false,
                    detailsLabel: labels?.detail?.[languageObj?.id],
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: true,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: true,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result
            ];

            $(`#${dtId}`).DataTable().row.add(advancedCommandDtLocal).draw();

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}<br/>`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ isModalClose: true, subMethod: currentMethod });
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const advancedCommandEdit = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'advancedCommandEdit';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = formDataValidate({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            response = await AdvancedCommandService.update({
                id: advancedCommand?.id,
                token: auth?.account?.tokenVzLaML?.token,
                data: advancedCommand,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const advancedCommand_ = response?.result?.advancedCommand || {};
            setAdvancedCommand(advancedCommand_);

            const advancedCommandDtLocal = [
                advancedCommand_?.description,
                setBadgeStatusGeneric({
                    type: (advancedCommand_?.status ? 0 : 1),
                    value: (advancedCommand_?.status ? labels?.enabled?.[languageObj?.id] : labels?.disabled?.[languageObj?.id])
                }),
                getProcessButtons({
                    id: advancedCommand_?.id,
                    description: advancedCommand_?.description,
                    detailsShow: false,
                    detailsLabel: labels?.detail?.[languageObj?.id],
                    detailsEnabled: false,
                    editShow: true,
                    editLabel: labels?.edit?.[languageObj?.id],
                    editEnabled: true,
                    deleteShow: true,
                    deleteLabel: labels?.delete?.[languageObj?.id],
                    deleteEnabled: true,
                    processButtons: [],
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                })?.result
            ];

            $(`#${dtId}`).DataTable().row(dtRowId).data(advancedCommandDtLocal).draw();

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}<br/>`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ isModalClose: true, subMethod: currentMethod });
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    const formDataValidate = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { description: '' };

            if (isUndNullEmpNew({ data: advancedCommand?.description, subMethod: currentMethod })?.result) {
                errors_.description = thisFieldRequired;
                response = getResponse({ type: 1 });
            }

            setErrors(errors_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const setFormValue = ({
        key = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFormValue';
        let response = getResponse({ type: 0 });
        try {
            setAdvancedCommand(prev => ({ ...prev, [key]: value }));

            if (key === 'description' && value !== '') {
                setErrors(prev => ({ ...prev, description: '' }));
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    };

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (showModal) {
                setErrors({
                    description: '',
                });
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!response?.isSuccess || response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    };

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => { isMount.current = false; };
    }, [advancedCommand?.id]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static'
            onHide={() => setDefaultValue({ isModalClose: true, subMethod: 'btnModalClose' })}
            show={showModal}
            centered
            contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='commandLogo' src={images?.icons?.advancedCommands} style={{ width: '20px', height: '20px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.advancedCommands?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className={`badge badge-pill py-1 px-2 text-uppercase ${type === 0 ? 'badge-info' : 'badge-warning text-dark'}`}
                            style={html?.badges?.micro}>
                            {type === 0 ? labels?.add?.[languageObj?.id] : labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={(e) => type === 0 ? advancedCommandAdd({ e, subMethod: 'form - onSubmit' }) : type === 1 ? advancedCommandEdit({ e, subMethod: 'form - onSubmit' }) : e.preventDefault()}>
                <Modal.Body className='px-4 pt-2'>
                    {type === 0 || type === 1 ? (
                        <>
                            <div className='form-group mb-4'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.description?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                        title={labels?.description?.[languageObj?.id]}
                                        type='text'
                                        onChange={(e) => setFormValue({ key: 'description', value: e?.target?.value, subMethod: 'inputDescription' })}
                                        onFocus={() => setErrors(prev => ({ ...prev, description: '' }))}
                                        placeholder={labels?.description?.[languageObj?.id]}
                                        value={advancedCommand?.description || ''}
                                        disabled={process?.showLoading} />
                                </div>
                                {errors?.description && <div className={html?.errorText}>{HtmlParser(errors?.description || '')}</div>}
                            </div>

                            <div className='form-group mb-4'>
                                <div className='icheck-primary d-inline'>
                                    <input type='checkbox'
                                        id={chkAdvancedCommandStatusId}
                                        checked={advancedCommand?.status || false}
                                        onChange={(e) => setFormValue({ key: 'status', value: e?.target?.checked, subMethod: 'chkStatus' })}
                                        disabled={process?.showLoading} />
                                    <label htmlFor={chkAdvancedCommandStatusId} style={{ cursor: 'pointer' }}>
                                        {labels?.enabled?.[languageObj?.id]}?
                                    </label>
                                </div>
                            </div>
                        </>
                    ) : null}
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setDefaultValue({ isModalClose: true, subMethod: 'btnFooterCloser' })}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}